export enum AdditionalDataLinkEnum
{
    VEHICLE = 'VEHICLE',
    INSURANCE_CONTRACT = 'INSURANCE_CONTRACT',
    MAINTENANCE_CONTRACT = 'MAINTENANCE_CONTRACT',
    USE_CONTRACT = 'USE_CONTRACT',
    VERIFICATION = 'VERIFICATION'
}